/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function BarChartFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="bar-chart-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M4.25 19.75L8.25 19.75L8.25 9.778C8.224 9.511 8.097 9.329 7.884 9.116C7.617 8.849 7.399 8.717 7 8.75L5.5 8.75C5.101 8.717 4.883 8.849 4.616 9.116C4.349 9.383 4.217 9.601 4.25 10L4.25 19.75ZM14.25 5.5C14.283 5.101 14.151 4.883 13.884 4.616C13.617 4.349 13.399 4.217 13 4.25L11 4.25C10.601 4.217 10.383 4.349 10.116 4.616C9.849 4.883 9.717 5.101 9.75 5.5L9.75 19.75L14.25 19.75L14.25 5.5ZM19.75 19.75L19.75 13C19.783 12.601 19.651 12.383 19.384 12.116C19.117 11.849 18.899 11.717 18.5 11.75L17 11.75C16.601 11.717 16.383 11.849 16.116 12.116C15.903 12.329 15.776 12.511 15.75 12.778L15.75 19.75L19.75 19.75Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
